import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KpiCardComponent } from '@shared/components/kpi-card/kpi-card.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CreatorsKpiCardsStore } from './creators-kpi-cards.store';

@Component({
  imports: [KpiCardComponent, TranslateModule, NgxSkeletonLoaderModule],
  providers: [CreatorsKpiCardsStore],
  selector: 'app-creators-kpi-cards',
  templateUrl: './creators-kpi-cards.component.html',
})
export class CreatorsKpiCardsComponent {
  public readonly store = inject(CreatorsKpiCardsStore);

  constructor() {
    this.store.fetchCreatorsStats();
  }
}
